import {
	LOADING_STATUS
} from '../actions/loading';

const INITIAL_STATE = false;

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {

        case LOADING_STATUS:// return list of posts and make loading = false
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer-loading.js